module.exports = __webpack_public_path__ + "img/login.81459600.png";